import type { BuildingRoomsSections } from "../../../types/buildings-sections/rooms";

export const roomsSection: BuildingRoomsSections = {
  title: "Ruumid ja alad",
  description: "Ruumide ja alade info",
  noRoomsAvailable: "Ruumid puuduvad",
  addRoom: "Lisa ruum",
  editRoom: "Muuda ruumi",
  deleteRoom: "Kustuta ruum",
  noRoomsData: "Ruumide andmed puuduvad",
  roomName: "Ruumi nimi",
  floorNumber: "Korrus",
  height: "Kõrgus (m)",
  floor: "Korrus",
  roomNumber: "Ruumi number",
  roomType: "Ruumi tüüp",
  area: "Pindala",
  status: "Olek",
  price: "Hind",
  // New spaces-related translations
  spaces: "Alad",
  addSpace: "Lisa ala",
  spaceName: "Ala nimi",
  spaceNumber: "Ala number",
  tenant: "Rentnik",
  addTenant: "Lisa rentnik",
  noSpaces: "Alad puuduvad",
  noRoomsInSpace: "Selles alas pole ruume",
  useType: "Kasutuse tüüp",
  commercial: "Äriline",
  residential: "Elamispind",
  tenantName: "Rentniku nimi",
  tenantContact: "Kontakt",
  tenantEmail: "E-post",
  tenantPhone: "Telefon",
  tenantNotes: "Märkmed",
  createTenant: "Loo rentnik",
  cancel: "Tühista",
  save: "Salvesta",
  selectTenant: "Vali rentnik",
  noTenant: "Rentnik puudub",
};
